// src/components/ChatAudioRecorder.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Button, message } from 'antd';
import { AudioOutlined, StopOutlined, PlayCircleOutlined, SendOutlined } from '@ant-design/icons';

export default function ChatAudioRecorder({ leadPhone, onRecording, onRecorded }) {
  const [recording, setRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioURL, setAudioURL] = useState(null);
  const audioChunksRef = useRef([]);

  useEffect(() => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        const mr = new MediaRecorder(stream);
        mr.ondataavailable = e => audioChunksRef.current.push(e.data);
        mr.onstop = () => {
          const blob = new Blob(audioChunksRef.current, { type: 'audio/ogg; codecs=opus' });
          const url = URL.createObjectURL(blob);
          setAudioURL({ url, blob });
      onRecorded({ url, blob });
          audioChunksRef.current = [];
        };
        setMediaRecorder(mr);
      })
      .catch(err => {
        console.error(err);
        message.error('No se pudo acceder al micrófono');
      });
  }, []);

  const toggleRecording = () => {
       if (!mediaRecorder) return;
       if (recording) {
         mediaRecorder.stop();
       } else {
         audioChunksRef.current = [];
         mediaRecorder.start();
       }
       setRecording(!recording);
       onRecording(!recording);
  };

  const sendAudio = () => {
    if (!audioURL?.blob) return;
    const formData = new FormData();
    formData.append('audio', audioURL.blob, 'voice.ogg');
    formData.append('phone', leadPhone);

    fetch(`${process.env.REACT_APP_API_URL}/api/whatsapp/send-audio`, {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(res => {
        if (res.success) {
          message.success('Nota de voz enviada');
          URL.revokeObjectURL(audioURL.url);
          setAudioURL(null);
        } else {
          message.error('Error al enviar audio');
        }
      })
      .catch(() => {
        message.error('Fallo de red al enviar audio');
      });
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Button
        onClick={toggleRecording}
        icon={recording ? <StopOutlined /> : <AudioOutlined />}
        type={recording ? 'danger' : 'default'}
      >
        {recording ? 'Detener' : 'Grabar'}
      </Button>

      {audioURL && (
        <>
          <audio src={audioURL.url} controls style={{ maxWidth: 200 }} />
          <Button
            icon={<SendOutlined />}
            onClick={sendAudio}
            type="primary"
          >
            Enviar
          </Button>
        </>
      )}
    </div>
  );
}
